import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import SuperAdminHeader from '../../components/SuperAdminHeader';
import SuperAdminDashboard from './SuperAdminDashboard';
import CreditPlansPage from './CreditPlansPage';
import ERPAPIKeysPage from './ERPAPIKeysPage';
import WebhookConfigPage from './WebhookConfigPage';
import TenantManagementPage from './TenantManagementPage';
import AuditLogsPage from './AuditLogsPage';
import APIDocumentationPage from './APIDocumentationPage';
import SystemConfigPage from './SystemConfigPage';

const { Content } = Layout;

const SuperAdminPortal: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <SuperAdminHeader />
      <Content style={{ background: '#f0f2f5' }}>
        <Routes>
          <Route path="/" element={<Navigate to="/super-admin/dashboard" replace />} />
          <Route path="/dashboard" element={<SuperAdminDashboard />} />
          <Route path="/credit-plans" element={<CreditPlansPage />} />
          <Route path="/api-keys" element={<ERPAPIKeysPage />} />
          <Route path="/webhook-config" element={<WebhookConfigPage />} />
          <Route path="/tenants" element={<TenantManagementPage />} />
          <Route path="/audit-logs" element={<AuditLogsPage />} />
          <Route path="/api-docs" element={<APIDocumentationPage />} />
          <Route path="/system-config" element={<SystemConfigPage />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default SuperAdminPortal;
